import React, { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { api } from "@/api";
import { useLang } from "@/i18n";

export const NewsletterBox = ({ variant = "inline" }) => {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // null | loading | done | already
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, lang });
      if (data.status === "already_subscribed") {
        setStatus("already");
        setMsg(t("news_already"));
      } else {
        setStatus("done");
        setMsg(t("news_done"));
      }
      setEmail("");
    } catch (err) {
      setStatus("done");
      setMsg(t("news_done"));
    }
  };

  const done = status === "done" || status === "already";

  return (
    <div
      data-testid={`newsletter-box-${variant}`}
      className="border-l-4 border-[#E63946] bg-[#14161b] rounded-r-lg p-6 sm:p-8"
    >
      <div className="flex items-center gap-2 text-[#E63946]">
        <Mail size={18} />
        <span className="text-xs font-mono uppercase tracking-[0.2em]">{t("news_title")}</span>
      </div>
      <h3 className="font-heading text-2xl sm:text-3xl font-extrabold uppercase text-white mt-2">{t("news_title")}</h3>
      <p className="text-sm text-zinc-400 mt-2 mb-5 max-w-md">{t("news_sub")}</p>
      {done ? (
        <div data-testid="newsletter-success" className="text-sm font-semibold text-[#10B981]">
          {msg}
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md">
          <input
            type="email"
            required
            value={email}
            data-testid="newsletter-email-input"
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("news_placeholder")}
            className="flex-1 bg-[#0c0d10] border border-[#272b35] rounded-md px-4 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:outline-none focus:border-[#E63946]"
          />
          <button
            type="submit"
            data-testid="newsletter-submit-btn"
            disabled={status === "loading"}
            className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-[#E63946] hover:bg-[#D90429] text-white text-sm font-bold uppercase rounded-md transition-colors disabled:opacity-60"
          >
            {status === "loading" && <Loader2 size={16} className="animate-spin" />}
            {t("news_btn")}
          </button>
        </form>
      )}
    </div>
  );
};
